import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TextareaField from '../../elements/form/TextareaField'
import RadioGroup from '../../elements/form/RadioGroup'
import { createExeat } from '../../../store/actions/exeatsActions'
import { ERROR } from '../../../store/types'
import ModalActionButton from '../../elements/ModalActionButton'
import DateField from '../../elements/form/DateField'
import moment from 'moment'
import TextField from '../../elements/form/TextField'

const NewExeat = ({student, term, close, reload}) => {
    const dispatch = useDispatch()
    const exeatsSelector = useSelector(state => state.exeats)
    const [exeatPayload, setExeatPayload] = useState({
        student: student._id,
        term: term._id
    })

    const [validationErrors, setValidationErrors] = useState({})

    const exeatBases = [
        {
            label: 'Religious',
            value: 'religious'
        },
        {
            label: 'Medical',
            value: 'medical'
        },
        {
            label: 'Holiday',
            value: 'holiday'
        },
        {
            label: 'Other',
            value: 'other'
        },
    ]

    const validateForm = () => {
        let errors = {}
        
        if(!exeatPayload.reasonType || exeatPayload.reasonType === '') {
            errors.reasonType = true
        }
  
        if(!exeatPayload.dateFrom || exeatPayload.dateFrom === '') {
            errors.dateFrom = true
        }

        if(!exeatPayload.dateTo || exeatPayload.dateTo === '') {
            errors.dateTo = true
        }

        if(!exeatPayload.pickupName || exeatPayload.pickupName === '') {
            errors.pickupName = true
        }

        if(!exeatPayload.pickupEmail || exeatPayload.pickupEmail === '') {
            errors.pickupEmail = true
        }

        if(!exeatPayload.pickupPhone || exeatPayload.pickupPhone === '') {
            errors.pickupPhone = true
        }
        setValidationErrors(errors)
        return errors
    }

    const pushExeat = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }
        const payload = {
            ...exeatPayload,
            dates: {
                from: exeatPayload.dateFrom,
                to: exeatPayload.dateTo
            },
            pickup: {
                name: exeatPayload.pickupName,
                phone: exeatPayload.pickupPhone,
                email: exeatPayload.pickupEmail
            }
        }
        dispatch(createExeat(payload))
    }

    return (
        <div className='w-full'>
            <div className='mb-2'>
                <RadioGroup 
                    items={exeatBases} 
                    inline={true}
                    preSelectedIndex={exeatBases.findIndex(item => item.value === exeatPayload.reasonType)}
                    inputLabel={'Basis for exeat'}
                    requiredField={true}
                    returnSelected={(value) => {setExeatPayload({...exeatPayload, ...{reasonType: value.value}})}} 
                    hasError={validationErrors && validationErrors.reasonType}  
                    titleField='label'
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Exeat note/Reason" 
                    fieldId="check-n-note" 
                    inputType="text" 
                    requiredField={false}
                    inputPlaceholder="You can add a note if necessary"
                    preloadValue={exeatPayload.reason || ''}
                    hasError={false} 
                    returnFieldValue={(value)=>{setExeatPayload({...exeatPayload, reason: value})}}
                />
            </div>

            <div className='w-full flex items-start justify-between gap-x-[10px]'>
                <div className='my-2 w-full'>
                    <DateField
                        inputLabel="From" 
                        fieldId="start-date" 
                        requiredField={true}
                        inputType="text" 
                        preloadValue={(moment(exeatPayload.dateFrom).format('YYYY-MM-DD')) || ''}
                        hasError={validationErrors && validationErrors.dateFrom} 
                        returnFieldValue={(value)=>{
                            // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                            setExeatPayload({...exeatPayload, ...{dateFrom: new Date(value)}})
                        }}
                    />
                </div>
                <div className='my-2 w-full'>
                    <DateField
                        inputLabel="To" 
                        fieldId="end-date" 
                        requiredField={true}
                        inputType="text" 
                        preloadValue={(moment(exeatPayload.dateTo).format('YYYY-MM-DD')) || ''}
                        hasError={validationErrors && validationErrors.dateTo} 
                        returnFieldValue={(value)=>{
                            // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                            setExeatPayload({...exeatPayload, ...{dateTo: new Date(value)}})
                        }}
                    />
                </div>
            </div>

            <div className='mb-2 mt-4 w-full'>
                <h3 className='font-space-grotesk text-[15px] font-[550] mb-[5px]'>Student Pickup</h3>
                <p className='text-sm text-gray-600'>Please provide details of the person that will pick up the student from the college. This individual will receive a pickup code to present to school security when the exeat is approved.</p>
            </div>

            <div className='my-2 w-full'>
                <TextField
                    inputLabel="Name" 
                    fieldId="pickup-name" 
                    inputType="text" 
                    inputPlaceholder={`Full name of the person`}
                    preloadValue={''}
                    hasError={validationErrors.pickupName} 
                    returnFieldValue={(value)=>{setExeatPayload({...exeatPayload, ...{pickupName: value}})}}
                    requiredField={true}
                />
            </div>

            <div className='my-2 w-full'>
                <TextField
                    inputLabel="Email address" 
                    fieldId="pickup-email" 
                    inputType="text"
                    preloadValue={``} 
                    inputPlaceholder={'An active email address'}
                    hasError={validationErrors.pickupEmail} 
                    returnFieldValue={(value)=>{setExeatPayload({...exeatPayload, ...{pickupEmail: value}})}}
                    requiredField={true}
                />
            </div>

            <div className='my-2 w-full'>
                <TextField
                    inputLabel="Phone number" 
                    fieldId="pickup-phone" 
                    inputType="text"
                    preloadValue={''} 
                    inputPlaceholder={`The person's active phone number`}
                    hasError={validationErrors.pickupPhone} 
                    returnFieldValue={(value)=>{setExeatPayload({...exeatPayload, ...{pickupPhone: value}})}}
                    requiredField={true}
                />
            </div>
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Exeat`}
                    buttonAction={()=>{pushExeat()}}
                    processing={exeatsSelector.creatingExeat}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default NewExeat